<template>
  <SamplesBrowse />
</template>

<script>
import SamplesBrowse from "@/components/samples/SamplesBrowse";

export default {
  name: "Browse",
  components: { SamplesBrowse }
};
</script>

<style scoped></style>
